import React from "react";
import { connect } from "react-redux";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { dgInput, dgRecaptcha, dgSelect, dgTextArea, email, phoneNumber, required } from "dg-forms";
import intl from "react-intl-universal";

let Contact_Form = (props) => {
  const {
    handleSubmit,
    submitting,
    onSubmit,
    reason
  } = props;

  const reasons = [
    "cardBlocked",
    "waitingForIDVerification",
    "cardNotDelivered",
    "missingTransfer",
    "cantLogin",
    "mobileNumberNotVerified",
    "closeMyAccount",
    "other"
  ];

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css" integrity="sha512-Evv84Mr4kqVGRNSgIGL/F/aIDqQb7xQ2vcrdIwxfjThSH8CSR7PBEakCr51Ck+w+/U6swU2Im1vVX0SVk9ABhg==" crossOrigin="anonymous" referrerPolicy="no-referrer" />

      <div>
        <Field
          name="name"
          type="text"
          component={dgInput}
          label={intl.get("page.Contact.Form.name.label")}
          labelClass="required"
          validate={[required]}
        />
        <i className="fa fa-user" aria-hidden="true"></i>
      </div>

      <div>
        <Field
          name="email"
          type="email"
          component={dgInput}
          label={intl.get("page.Contact.Form.email.label")}
          labelClass="required"
          validate={[required, email]}
        />
        <i className="fa fa-envelope" aria-hidden="true"></i>
      </div>

      <div>
        <Field
          name="phone"
          type="tel"
          component={dgInput}
          label={intl.get("page.Contact.Form.phone.label")}
          labelClass="required"
          validate={[required, phoneNumber]}
        />
        <i className="fa fa-phone" aria-hidden="true"></i>
      </div>

      <div>
        <Field
          name="reason"
          labelClass="required"
          label={intl.get("page.Contact.Form.reason.label")}
          customSelect={
            reason === "" || reason === undefined
              ? `select empty`
              : `select`
          }
          component={dgSelect}
          validate={[]}
        >
          <option value="" selected>
            {intl.get("page.Contact.Form.reason.label")}
          </option>
          {
            reasons.map(v => (
              <option value={v}>
                {intl.get("page.Contact.Form.reason.options." + v)}
              </option>
            ))
          }
        </Field>
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
      </div>

      {/*<div>*/}
      {/*  <Field*/}
      {/*    name="description"*/}
      {/*    component={dgTextArea}*/}
      {/*    containerClass="field-group"*/}
      {/*    inputClass=""*/}
      {/*    label="Description"*/}
      {/*    labelClass="required"*/}
      {/*    placeholder="Description*"*/}
      {/*    rows="8"*/}
      {/*    validate={[required]}*/}
      {/*  />*/}
      {/*  <i className="fa fa-user" aria-hidden="true"></i>*/}
      {/*</div>*/}

      {/*<Field*/}
      {/*  name="recaptcha"*/}
      {/*  component={dgRecaptcha}*/}
      {/*  validate={[required]}*/}
      {/*/>*/}

      <div className="field-group">
        <button
          type="submit"
          disabled={submitting}
          className="btn-primary"
        >
          Submit
        </button>
      </div>
    </form>
  );
};

Contact_Form = reduxForm({
  form: "Contact_Form"
})(Contact_Form);

const selector = formValueSelector("Contact_Form");
Contact_Form = connect((state) => {
  const reason = selector(state, "reason");

  return {
    reason
  };
}, {})(Contact_Form);

export const ContactForm = Contact_Form;
